import React, { useState, useRef, useEffect } from "react";
import ReactPlayer from "react-player";
import "../../../styles/style.css";
import videoSource from "../../../assets/videos/videosource16";
import { quizQuestions } from "../../../assets/questions/quizquestions16";
import { db, auth, doc, updateDoc, getDoc } from "../../../firebase";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import NavbarDashboard from "../../../components/Navbar/NavbarDashboard";

const PavementArrow = () => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState(
    Array(quizQuestions.length).fill("")
  );
  const [videoPlayed, setVideoPlayed] = useState(false);
  const [quizFinished, setQuizFinished] = useState(false);
  const [isVideoEnded, setIsVideoEnded] = useState(false);
  const [userTotalQuizzesDone, setUserTotalQuizzesDone] = useState(0);
  const [showPrompt, setShowPrompt] = useState(false);
  const [showCorrectFeedback, setShowCorrectFeedback] = useState(false);
  const playerRef = useRef(null);

  const currentVideo = videoSource.find(
    (video) => video.id === quizQuestions[currentQuestionIndex].videoId
  );

  const handleOptionSelect = (option) => {
    const updatedAnswers = [...userAnswers];
    updatedAnswers[currentQuestionIndex] = option;
    setUserAnswers(updatedAnswers);
  };

  const handleNextQuestion = () => {
    if (currentQuestionIndex + 1 < quizQuestions.length) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setVideoPlayed(false);
      setIsVideoEnded(false);
      setShowPrompt(false); // Hide the prompt for the next question
    } else {
      // Quiz is finished
      setQuizFinished(true);
    }
  };

  const handleVideoEnd = () => {
    setIsVideoEnded(true);
  };

  const handleCheckAnswer = () => {
    if (
      userAnswers[currentQuestionIndex] !==
      quizQuestions[currentQuestionIndex].correctAnswer
    ) {
      setShowPrompt(true);
      setShowCorrectFeedback(false); // Hide correct feedback
    } else {
      setShowPrompt(false);
      setShowCorrectFeedback(true); // Show correct feedback
      setTimeout(() => {
        handleNextQuestion();
      }, 2000); // Delay next question for 2 seconds to display correct feedback
    }
  };

  const markQuizAsFinished = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;

      // Reference to the "topic" subcollection
      const userDocRef = doc(db, "users", userId, "pavement", userId);

      // Reference to the user document directly
      const userRootDocRef = doc(db, "users", userId);

      try {
        // Fetch user data to check if totalQuizzesDone field exists
        const userDoc = await getDoc(userRootDocRef);

        // If totalQuizzesDone field doesn't exist, initialize it to 0
        const initialTotalQuizzesDone = userDoc.exists
          ? userDoc.data().totalQuizzesDoneTS || 0
          : 0;

        // Update the "topic" subcollection
        await updateDoc(userDocRef, {
          quizFinished: true,
        });

        // Update the root user document
        await updateDoc(userRootDocRef, {
          totalQuizzesDoneTS: initialTotalQuizzesDone + 1,
        });

        console.log("Quiz marked as finished for the user with ID: ", userId);
        setQuizFinished(true);
        alert("Lesson marked as finished!");
      } catch (error) {
        console.error("Error marking quiz as finished:", error);
      }
    }
  };

  useEffect(() => {
    const user = auth.currentUser; // Get the currently logged-in user
    if (user) {
      const userId = user.uid; // Get the user's UID
      const userDocRef = doc(db, "users", userId, "pavement", userId);

      // Fetch user data from Firestore
      getDoc(userDocRef)
        .then((doc) => {
          if (doc.exists()) {
            // Update the state with the total quizzes done
            setUserTotalQuizzesDone(doc.data().totalQuizzesDoneTS || 0);

            // If the user has finished the quiz, set the quizFinished state to true
            setQuizFinished(doc.data().quizFinished || false);
          }
        })
        .catch((error) => {
          console.error("Error fetching user data:", error);
        });
    }
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!quizFinished) {
        event.preventDefault();
        event.returnValue = ""; // For older browsers
        return "You have unsaved progress. Are you sure you want to leave the quiz page?";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [quizFinished]);

  useEffect(() => {
    if (showCorrectFeedback) {
      const timeoutId = setTimeout(() => {
        setShowCorrectFeedback(false); // Hide correct feedback after 2 seconds
      }, 2000);
      return () => clearTimeout(timeoutId);
    }
  }, [showCorrectFeedback]);

  function incorrectAnswer() {
    alert("Incorrect Answer. Please try again.");
  }

  return (
    <div className="container-dashboard">
      <NavbarDashboard />

      <div className="lesson-wrapper">
        <div className="lesson-video-wrapper">
          <div className="video_player">
            <ReactPlayer
              ref={playerRef}
              url={currentVideo.src}
              playing={videoPlayed}
              controls={true}
              onEnded={handleVideoEnd}
              width="100%"
              height="100%"
            />
          </div>

          <div className="lesson-video-navigation">
            <h1 className="video_title">
              {quizQuestions[currentQuestionIndex].descriptionTitle}
            </h1>
            <p className="video_description">
              {quizQuestions[currentQuestionIndex].description1}
            </p>
          </div>
        </div>

        <div className="interactive_panel_wrapper">
          <h2>Interactive Panel</h2>
          <div className="lesson_notes">
            <h4>Question:</h4>
            <p>{quizQuestions[currentQuestionIndex].question}</p>
          </div>
          <div className="lesson_question_wrapper">
            <div className="lesson_question_choices">
              {quizFinished ? (
                <div>
                  <h2>Lesson Finished!</h2>
                  <button className="mark_finish" onClick={markQuizAsFinished}>
                    Mark as Finished
                  </button>
                  <Link className="mark_finish" to="/ts_rm_main">
                    <button className="mark_finish">Back</button>
                  </Link>
                </div>
              ) : (
                <div className="radio-container">
                  <h4>Choices</h4>
                  {quizQuestions[currentQuestionIndex].options.map(
                    (option, index) => (
                      <label className="radio-label" key={option}>
                        <input
                          type="radio"
                          value={index + 1}
                          checked={userAnswers[currentQuestionIndex] === option}
                          onChange={() => handleOptionSelect(option)}
                        />
                        {option}
                      </label>
                    )
                  )}
                  <button
                    type="submit"
                    className="submit_choice"
                    onClick={handleCheckAnswer}
                  >
                    Submit
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="lesson_notes">
            {showPrompt && (
              <p className="incorrect-text">
                Sorry, that's incorrect. Please try again.
              </p>
            )}
            {showCorrectFeedback && (
              <p className="correct-text">
                Congratulations! That's the correct answer.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PavementArrow;
